export default "__VITE_ASSET__Dz9GDGgS__"